export const getCountryISO2 = (countryCode: string) => {
  if (countryCode.length < 3) {
    return countryCode;
  }

  return {
    ENG: 'GB',
    NIR: 'GB',
    AFG: "AF",
    ALA: "AX",
    ALB: "AL",
    DZA: "DZ",
    ASM: "AS",
    AND: "AD",
    AGO: "AO",
    AIA: "AI",
    ATA: "AQ",
    ATG: "AG",
    ARG: "AR",
    ARM: "AM",
    ABW: "AW",
    AUS: "AU",
    AUT: "AT",
    AZE: "AZ",
    BHS: "BS",
    BHR: "BH",
    BGD: "BD",
    BRB: "BB",
    BLR: "BY",
    BEL: "BE",
    BLZ: "BZ",
    BEN: "BJ",
    BMU: "BM",
    BTN: "BT",
    BOL: "BO",
    BES: "BQ",
    BIH: "BA",
    BWA: "BW",
    BVT: "BV",
    BRA: "BR",
    VGB: "VG",
    IOT: "IO",
    BRN: "BN",
    BGR: "BG",
    BFA: "BF",
    BDI: "BI",
    KHM: "KH",
    CMR: "CM",
    CAN: "CA",
    CPV: "CV",
    CYM: "KY",
    CAF: "CF",
    TCD: "TD",
    CHL: "CL",
    CHN: "CN",
    HKG: "HK",
    MAC: "MO",
    CXR: "CX",
    CCK: "CC",
    COL: "CO",
    COM: "KM",
    COG: "CG",
    COD: "CD",
    COK: "CK",
    CRI: "CR",
    CIV: "CI",
    HRV: "HR",
    CUB: "CU",
    CUW: "CW",
    CYP: "CY",
    CZE: "CZ",
    DNK: "DK",
    DJI: "DJ",
    DMA: "DM",
    DOM: "DO",
    ECU: "EC",
    EGY: "EG",
    SLV: "SV",
    GNQ: "GQ",
    ERI: "ER",
    EST: "EE",
    ETH: "ET",
    FLK: "FK",
    FRO: "FO",
    FJI: "FJ",
    FIN: "FI",
    FRA: "FR",
    GUF: "GF",
    PYF: "PF",
    ATF: "TF",
    GAB: "GA",
    GMB: "GM",
    GEO: "GE",
    DEU: "DE",
    GHA: "GH",
    GIB: "GI",
    GRC: "GR",
    GRL: "GL",
    GRD: "GD",
    GLP: "GP",
    GUM: "GU",
    GTM: "GT",
    GGY: "GG",
    GIN: "GN",
    GNB: "GW",
    GUY: "GY",
    HTI: "HT",
    HMD: "HM",
    VAT: "VA",
    HND: "HN",
    HUN: "HU",
    ISL: "IS",
    IND: "IN",
    IDN: "ID",
    IRN: "IR",
    IRQ: "IQ",
    IRL: "IE",
    IMN: "IM",
    ISR: "IL",
    ITA: "IT",
    JAM: "JM",
    JPN: "JP",
    JEY: "JE",
    JOR: "JO",
    KAZ: "KZ",
    KEN: "KE",
    KIR: "KI",
    PRK: "KP",
    KOR: "KR",
    KWT: "KW",
    KGZ: "KG",
    LAO: "LA",
    LVA: "LV",
    LBN: "LB",
    LSO: "LS",
    LBR: "LR",
    LBY: "LY",
    LIE: "LI",
    LTU: "LT",
    LUX: "LU",
    MKD: "MK",
    MDG: "MG",
    MWI: "MW",
    MYS: "MY",
    MDV: "MV",
    MLI: "ML",
    MLT: "MT",
    MHL: "MH",
    MTQ: "MQ",
    MRT: "MR",
    MUS: "MU",
    MYT: "YT",
    MEX: "MX",
    FSM: "FM",
    MDA: "MD",
    MCO: "MC",
    MNG: "MN",
    MNE: "ME",
    MSR: "MS",
    MAR: "MA",
    MOZ: "MZ",
    MMR: "MM",
    NAM: "NA",
    NRU: "NR",
    NPL: "NP",
    NLD: "NL",
    ANT: "AN",
    NCL: "NC",
    NZL: "NZ",
    NIC: "NI",
    NER: "NE",
    NGA: "NG",
    NIU: "NU",
    NFK: "NF",
    MNP: "MP",
    NOR: "NO",
    OMN: "OM",
    PAK: "PK",
    PLW: "PW",
    PSE: "PS",
    PAN: "PA",
    PNG: "PG",
    PRY: "PY",
    PER: "PE",
    PHL: "PH",
    PCN: "PN",
    POL: "PL",
    PRT: "PT",
    PRI: "PR",
    QAT: "QA",
    REU: "RE",
    ROU: "RO",
    RUS: "RU",
    RWA: "RW",
    BLM: "BL",
    SHN: "SH",
    KNA: "KN",
    LCA: "LC",
    MAF: "MF",
    SPM: "PM",
    VCT: "VC",
    WSM: "WS",
    SMR: "SM",
    STP: "ST",
    SAU: "SA",
    SEN: "SN",
    SRB: "RS",
    SYC: "SC",
    SLE: "SL",
    SGP: "SG",
    SXM: "SX",
    SVK: "SK",
    SVN: "SI",
    SLB: "SB",
    SOM: "SO",
    ZAF: "ZA",
    SGS: "GS",
    SSD: "SS",
    ESP: "ES",
    LKA: "LK",
    SDN: "SD",
    SUR: "SR",
    SJM: "SJ",
    SWZ: "SZ",
    SWE: "SE",
    CHE: "CH",
    SYR: "SY",
    TWN: "TW",
    TJK: "TJ",
    TZA: "TZ",
    THA: "TH",
    TLS: "TL",
    TGO: "TG",
    TKL: "TK",
    TON: "TO",
    TTO: "TT",
    TUN: "TN",
    TUR: "TR",
    TKM: "TM",
    TCA: "TC",
    TUV: "TV",
    UGA: "UG",
    UKR: "UA",
    ARE: "AE",
    GBR: "GB",
    USA: "US",
    UMI: "UM",
    URY: "UY",
    UZB: "UZ",
    VUT: "VU",
    VEN: "VE",
    VNM: "VN",
    VIR: "VI",
    WLF: "WF",
    ESH: "EH",
    YEM: "YE",
    ZMB: "ZM",
    ZWE: "ZW",
    XKX: "XK"
  }[countryCode];
}

export const getFrenchName = (code: string, backup: string) => {
  try {
    return {
      AFG: 'Afghanistan',
      ALA: 'Îles Aland',
      ALB: 'Albanie',
      DZA: 'Algérie',
      ASM: 'Samoa américaines',
      AND: 'Andorre',
      AGO: 'Angola',
      AIA: 'Anguilla',
      ATA: 'Antarctique',
      ATG: 'Antigua-et-Barbuda',
      ARG: 'Argentine',
      ARM: 'Arménie',
      ABW: 'Aruba',
      AUS: 'Australie',
      AUT: 'Autriche',
      AZE: 'Azerbaïdjan',
      BHS: 'Bahamas',
      BHR: 'Bahreïn',
      BGD: 'Bangladesh',
      BRB: 'Barbades',
      BLR: 'Biélorussie',
      BEL: 'Belgique',
      BLZ: 'Belize',
      BEN: 'Bénin',
      BMU: 'Bermudes',
      BTN: 'Bhoutan',
      BOL: 'Bolivie',
      BES: 'Saba, Saint-Eustache et Bonaire',
      BIH: 'Bosnie-Herzégovine',
      BWA: 'Botswana',
      BVT: 'Île Bouvet',
      BRA: 'Brésil',
      IOT: "Territoire Britannique de l'Océan Indien",
      VGB: 'Îles Vierges britanniques',
      BRN: 'Brunei',
      BGR: 'Bulgarie',
      BFA: 'Burkina Faso',
      BDI: 'Burundi',
      CPV: 'Cabo Verde',
      KHM: 'Cambodge',
      CMR: 'Cameroun',
      CAN: 'Canada',
      CYM: 'Îles Caïmans',
      CAF: 'République centrafricaine',
      TCD: 'Tchad',
      CHL: 'Chili',
      CHN: 'Chine',
      CXR: 'Îles Christmas',
      CCK: 'Îles Cocos',
      COL: 'Colombie',
      COM: 'Comores',
      COK: 'Îles Cook',
      CRI: 'Costa Rica',
      HRV: 'Croatie',
      CUB: 'Cuba',
      CUW: 'Curaçao',
      CYP: 'Chypre',
      CZE: 'Czechia',
      COD: 'République démocratique du Congo',
      DNK: 'Danemark',
      DJI: 'Djibouti',
      DMA: 'Dominique',
      DOM: 'République Dominicaine',
      ECU: 'Équateur',
      EGY: 'Égypte',
      SLV: 'Le Salvador',
      GNQ: 'Guinée équatoriale',
      ERI: 'Érythrée',
      EST: 'Estonie',
      SWZ: 'Eswatini',
      ETH: 'Éthiopie',
      FLK: 'Îles Falkland',
      FRO: 'Îles Féroé',
      FJI: 'Fiji',
      FIN: 'Finlande',
      FRA: 'France',
      GUF: 'Guyane française',
      PYF: 'Polynésie française',
      ATF: 'Terres australes et antarctiques françaises',
      GAB: 'Gabon',
      GMB: 'Gambie',
      GEO: 'État de Géorgie',
      DEU: 'Allemagne',
      GHA: 'Ghana',
      GIB: 'Gribraltar',
      GRC: 'Grèce',
      GRL: 'Groenland',
      GRD: 'Grenade',
      GLP: 'Guadeloupe',
      GUM: 'Guam',
      GTM: 'Guatémala',
      GGY: 'Guernesey',
      GIN: 'Guinée',
      GNB: 'Guinée-Bissau',
      GUY: 'Guyane',
      HTI: 'Haïti',
      HMD: 'Îles Heard et îles MacDonald',
      HND: 'Honduras',
      HKG: 'Hong Kong',
      HUN: 'Hongrie',
      ISL: 'Islande',
      IND: 'Inde',
      IDN: 'Indonésie',
      IRN: 'Iran',
      IRQ: 'Irak',
      IRL: 'Irlande',
      IMN: 'Île de Man',
      ISR: 'Israël',
      ITA: 'Italie',
      CIV: "Côte-d'Ivoire",
      JAM: 'Jamaïque',
      JPN: 'Japon',
      JEY: 'Jersey',
      JOR: 'Jordanie',
      KAZ: 'Kazakhstan',
      KEN: 'Kenya',
      KIR: 'Kiribati',
      XKX: 'Kosovo',
      KWT: 'Koweït',
      KGZ: 'Kirghizistan',
      LAO: 'Laos',
      LVA: 'Lettonie',
      LBN: 'Liban',
      LSO: 'Lesotho',
      LBR: 'Libéria',
      LBY: 'Libye',
      LIE: 'Liechtenstein',
      LTU: 'Lituanie',
      LUX: 'Luxembourg',
      MAC: 'Macao',
      MDG: 'Madagascar',
      MWI: 'Malawi',
      MYS: 'Malaysie',
      MDV: 'Maldives',
      MLI: 'Mali',
      MLT: 'Malte',
      MHL: 'Îles Marshall',
      MTQ: 'Martinique',
      MRT: 'Mauritanie',
      MUS: 'Île Maurice',
      MYT: 'Mayotte',
      MEX: 'Mexique',
      FSM: 'Micronésie',
      MDA: 'Moldavie',
      MCO: 'Monaco',
      MNG: 'Mongolie',
      MNE: 'Monténégro',
      MSR: 'Montserrat',
      MAR: 'Maroc',
      MOZ: 'Mozambique',
      MMR: 'Myanmar',
      NAM: 'Namibie',
      NRU: 'Nauru',
      NPL: 'Népal',
      ANT: 'Antilles néerlandaises',
      NCL: 'Nouvelle-Calédonie',
      NZL: 'Nouvelle Zélande',
      NIC: 'Nicaragua',
      NER: 'Niger',
      NGA: 'Nigéria',
      NIU: 'Niue',
      NFK: 'Île Norfolk',
      PRK: 'Corée du Nord',
      MKD: 'North Macedonia',
      MNP: 'Îles Mariannes du Nord',
      NOR: 'Norvège',
      OMN: 'Oman',
      PAK: 'Pakistan',
      PLW: 'Palaos',
      PSE: 'Territoire Palestinien',
      PAN: 'Panama',
      PNG: 'Papouasie-Nouvelle-Guinée',
      PRY: 'Paraguay',
      PER: 'Pérou',
      PHL: 'Philippines',
      PCN: 'Îles Pitcairn',
      POL: 'Pologne',
      PRT: 'Portugal',
      PRI: 'Puerto Rico',
      QAT: 'Qatar',
      COG: 'République du Congo',
      REU: 'La Réunion',
      ROU: 'Roumanie',
      RUS: 'Russie',
      RWA: 'Rwanda',
      BLM: 'Saint Barthélemy',
      SHN: 'Sainte-Hélène',
      KNA: 'Saint-Kitts-et-Nevis',
      LCA: 'Sainte-Lucie',
      MAF: 'Saint-Martin',
      SPM: 'Saint Pierre et Miquelon',
      VCT: 'Saint-Vincent-et-les-Grenadines',
      WSM: 'Samoa',
      SMR: 'San Marin',
      STP: 'Sao Tomé-et-Principe',
      SAU: 'Arabie Saoudite',
      SEN: 'Sénégal',
      SRB: 'Serbie',
      SCG: 'Serbie et Montenegro',
      SYC: 'Seychelles',
      SLE: 'Sierra Leone',
      SGP: 'Singapour',
      SXM: 'Saint-Martin',
      SVK: 'Slovaquie',
      SVN: 'Slovénie',
      SLB: 'Îles Salomon',
      SOM: 'Somalie',
      ZAF: 'Afrique du Sud',
      SGS: 'Géorgie du Sud et les îles Sandwich',
      KOR: 'Corée du Sud',
      SSD: 'Soudan du Sud',
      ESP: 'Espagne',
      LKA: 'Sri Lanka',
      SDN: 'Soudan',
      SUR: 'Surinam',
      SJM: 'Svalbard et Jan Mayen',
      SWE: 'Suède',
      CHE: 'Suisse',
      SYR: 'Syrie',
      TWN: 'Taiwan',
      TJK: 'Tajikistan',
      TZA: 'Tanzanie',
      THA: 'Thaïlande',
      NLD: 'The Netherlands',
      TLS: 'Timor Leste',
      TGO: 'Togo',
      TKL: 'Tokelau',
      TON: 'Tonga',
      TTO: 'Trinité et Tobago',
      TUN: 'Tunisie',
      TUR: 'Turquie',
      TKM: 'Turkménistan',
      TCA: 'Îles Turques et Caïques',
      TUV: 'Tuvalu',
      VIR: 'Îles Vierges des États-Unis',
      UGA: 'Ouganda',
      UKR: 'Ukraine',
      ARE: 'Émirats Arabes Unis',
      GBR: 'Royaume-Uni',
      USA: 'États-Unis (USA)',
      UMI: 'Îles Mineures éloignées des États-Unis',
      URY: 'Uruguay',
      UZB: 'Ouzbékistan',
      VUT: 'Vanuatu',
      VAT: 'Vatican',
      VEN: 'Vénézuela',
      VNM: 'Vietnam',
      WLF: 'Wallis et Futuna',
      ESH: 'Sahara occidental',
      YEM: 'Yemen',
      ZMB: 'Zambie',
      ZWE: 'Zimbabwe'
    }[code];
  } catch {
    return backup;
  }
}